import React from 'react';
import PropTypes from 'prop-types';
import './usp.scss';
import HygieneAndHealth from 'assets/usp-icons/hygiene.svg';
import Certificate from 'assets/usp-icons/certificates.svg';
import FastDelivery from 'assets/usp-icons/delivery.svg';
// import HalalCut from 'assets/usp-icons/halalcut.svg';
import Refund from 'assets/usp-icons/refund.svg';
import USPCard from './USP-card';

const USPs = [
  {
    uspId: 'hygiene',
    name: 'Best Hygiene & Health Standards',
    imagePath: HygieneAndHealth,
    actionUri: '/usp#hygiene',
  },
  // {
  //   uspId: 'certificate',
  //   name: 'Globally recognised, Halal certified',
  //   imagePath: Certificate,
  //   actionUri: '/usp#certificate',
  // },
  {
    uspId: 'fastDelivery',
    name: 'Next Day FRESH  Delivery',
    imagePath: FastDelivery,
    actionUri: '/usp#fastDelivery',
  },
  // {
  //   uspId: 'halalCut',
  //   name: 'Halal Cut',
  //   imagePath: HalalCut,
  //   actionUri: '/usp#halalCut',
  // },
  {
    uspId: 'refund',
    name: '100% guaranteed refund if dissatisfied',
    imagePath: Refund,
    actionUri: '/usp#refund',
  },
  {
    uspId: 'gradeA',
    name: 'Only Grade A',
    imagePath: Certificate,
    actionUri: '/usp#gradeA',
  },
];

const USP = ({ usps = USPs, scrollable }) => {
  return (
    <div className={`usp-container-small ${scrollable ? 'scrollable' : ''}`}>
      {usps.map((usp, index) => (
        <USPCard usp={usp} key={usp.uspId} last={index === usps.length - 1} />
      ))}
    </div>
  );
};

USP.propTypes = {
  usp: PropTypes.array,
  scrollable: PropTypes.bool,
};

export default USP;
